<script setup lang="ts">
import useMatestoreStore from '@/store/matestoreStore';
import MicroDialog from '@/components/micro-dialog/index';
interface GlobalSearchProps {
  size: string;
}

const props = defineProps<GlobalSearchProps>();

const microStore = useMatestoreStore();
function handleCallSearch() {
  MicroDialog.open({
    appName: 'search/appSearch',
  });
}
</script>

<template>
  <div
    v-if="size !== 'mini'"
    :class="{
      'global-search-input': true,
      'global-search-input--large': props.size === 'large',
      'global-search-input--middle': props.size === 'middle',
    }"
    @click="handleCallSearch"
    v-tit-tracker:click="{
      button_group: '搜索框',
      button_name: '搜索框',
      trackName: 'FrameClick',
      requirement_id: 754,
      track_sign: 'aplatform.b2862.c2866.click.FrameClick',
    }"
  >
    <NIconSVG name="search" size="16" class="tit-top-header-search-icon" />
    <span class="global-search-input__placeholder">搜索</span>
  </div>
  <n-button
    v-else
    type="text"
    icon="search"
    class="mate-btn-reverse-icon"
    @click="handleCallSearch"
    v-tit-tracker:click="{
      button_group: '搜索框',
      button_name: '搜索框',
      trackName: 'FrameClick',
      requirement_id: 754,
      track_sign: 'aplatform.b2862.c2866.click.FrameClick',
    }"
  ></n-button>
</template>

<style scoped lang="scss">
.global-search-input {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
  padding: 5px 12px;
  width: 320px;
  height: 32px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  color: var(--tit-header-search-color);
  &__placeholder {
    color: var(--tit-header-search-color);
  }
  &__icon {
    margin-right: 8px;
  }

  &--large {
    width: 320px;
  }

  &--mini {
    width: 32px;
    background: none;
    .global-search-input__placeholder {
      display: none;
    }
  }
  &--middle {
    width: 126px;
  }
}
</style>
